/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { faSave } from '@fortawesome/free-solid-svg-icons/faSave'
import { useIntl } from 'react-intl'
import FormSubmitButton, { FormSubmitButtonProps } from './FormSubmitButton'

function FormSaveButton (props: FormSubmitButtonProps) {
  const intl = useIntl()
  return (
    <FormSubmitButton
      {...props}
      icon={faSave}
      label={intl.formatMessage({ id: 'save', defaultMessage: 'Enregistrer' })}
    />
  )
}

export default FormSaveButton
